import { DataSourceOptions } from '../../interfaces/options';

export const DefaultDataSourceOptions: DataSourceOptions<any> = {};
